import { render, staticRenderFns } from "./PaymentRequestCommunication.vue?vue&type=template&id=d9047730&"
import script from "./PaymentRequestCommunication.vue?vue&type=script&lang=js&"
export * from "./PaymentRequestCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports